__turbopack_context__.v({
  "root": "scroll-fade-module__zTv_3W__root",
  "rootX": "scroll-fade-module__zTv_3W__rootX",
});
